import { Component, Input } from '@angular/core';
import { IlClass } from '@queries/generated';
import { PluralTranslateService } from '@services/plural-translate.service';

@Component({
  selector: 'vnm-il-class-availability',
  templateUrl: './il-class-availability.component.html',
  styleUrls: ['./il-class-availability.component.scss']
})
export class IlClassAvailabilityComponent {
  @Input() ilClass!: IlClass;

  constructor(private pluralTranslateService: PluralTranslateService) {}

  get i18nAvailableSeats(): string {
    return this.pluralTranslateService.instant('il-class-availability.spots-label', this.ilClass.availableSeats);
  }
}
